import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL, USER_URL } from "../../constant/api";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function AdminAddBanner() {
  const [products, setProducts] = useState([]);
   const [selectedProducts, setSelectedProducts] = useState([]);
   const [banner, setBanner] = useState({
     title: "",
     start_date: "",
     end_date: "",
     banner_image: null,
   });
   const [isSubmitting, setIsSubmitting] = useState(false);
   const token = localStorage.getItem("token");
   const navigate = useNavigate();
   // Fetch products on component load
   useEffect(() => {
     const fetchProducts = async () => {
       try {
         const response = await USER_URL.get(`/products/seller/`, {
          
         });
         if (response.data?.Data) {
           setProducts(response.data.Data);
         }
       } catch (error) {
         console.error("Error fetching products:", error.message || error);
         toast.error("Failed to fetch products!")
       }
     };
     fetchProducts();
   }, [token]);
 
   // Handle changes to the banner form
   const handleBannerChange = (e) => {
     const { name, value, files } = e.target;
     setBanner((prev) => ({
       ...prev,
       [name]: files ? files[0] : value,
     }));
   };
 
   // Handle selecting/deselecting a product
   const handleProductSelect = (productId) => {
     setSelectedProducts((prev) => {
       const existingProduct = prev.find((p) => p.product === productId);
   
       if (existingProduct) {
         // If already selected, remove it from the list
         return prev.filter((p) => p.product !== productId);
       } else {
         // If not selected, add it and retain its uploaded image if available
         const productWithImage = products.find((p) => p.id === productId);
         return [
           ...prev,
           {
             product: productId,
             product_banner_image: productWithImage?.product_banner_image || null,
           },
         ];
       }
     });
   };
   
   
 
   // Handle product-specific banner image changes
   const handleProductImageChange = (e, productId) => {
     const file = e.target.files[0];
   
     if (file) {
       const imageUrl = URL.createObjectURL(file);
   
       setSelectedProducts((prev) => {
         const productExists = prev.some((p) => p.product === productId);
   
         if (productExists) {
           // Update existing product's image
           return prev.map((p) =>
             p.product === productId ? { ...p, product_banner_image: file } : p
           );
         } else {
           // Automatically add product when an image is uploaded
           return [
             ...prev,
             {
               product: productId,
               product_banner_image: file,
             },
           ];
         }
       });
   
       // Update the products list for live image preview
       setProducts((prev) =>
         prev.map((p) =>
           p.id === productId
             ? { ...p, product_banner_image: file, imageUrl }
             : p
         )
       );
     }
   };
   
   
 
 
   // Submit banner data
   const handleSubmit = async () => {
     // Validate required fields
     if (!banner.title) {
      
       toast.warn("Please enter the banner title.")
       return;
     }
     if (!banner.banner_image) {
       toast.warn("Please upload a banner image.")
       return;
     }
     if (!banner.start_date) {
       toast.warn("Please select a start date.")
       return;
     }
     if (!banner.end_date) {
       toast.warn("Please select an end date.")
       return;
     }
     if (selectedProducts.length === 0) {
       toast.warn("Please select at least one product to include in the banner.")
       return;
     }
    
     // Validate product banner images
     const invalidProducts = selectedProducts.filter((p) => !p.product_banner_image);
     if (invalidProducts.length > 0) {
       // Generate a detailed alert with product names or IDs
       const missingImages = invalidProducts
         .map((p) => {
           const product = products.find((prod) => prod.id === p.product);
           return product ? `${product.name} (ID: ${product.id})` : `Product ID: ${p.product}`;
         })
         .join("\n");
         
       toast.warn("The following products are missing their images")
       return;
     }
     setIsSubmitting(true); // Set isSubmitting to true when the form submission starts
 
     // Prepare form data
     const formData = new FormData();
     formData.append("title", banner.title);
     formData.append("banner", banner.banner_image);
     formData.append("start_date", banner.start_date);
     formData.append("end_date", banner.end_date);
   
     // Append each product dynamically
     selectedProducts.forEach((p, index) => {
       formData.append(`banner_products[${index}]product`, p.product);
       formData.append(`banner_products[${index}]product_banner_image`, p.product_banner_image);
     });
   
     // Submit the form
     try {
       const response = await USER_URL.post(`/products/seller/banners/`, formData, {
         headers: {
           
           "Content-Type": "multipart/form-data",
         },
       });
       toast.success("Banner created successfully!");
       console.log("Response Data:", response.data);
       // Reset all state values to their initial states
     setBanner({
       title: "",
       start_date: "",
       end_date: "",
       banner_image: null,
     });
     setSelectedProducts([]);
     } catch (error) {
       console.error("Error creating banner:", error.response?.data || error.message || error);
   
       alert("Failed to create banner. Please try again.");
     } finally {
       setIsSubmitting(false); // Reset isSubmitting to false after submission completes
     }
   };
   return (
     <div> 
       <ToastContainer position="top-center" autoClose={3000} />
       
     <div className="border-2 rounded-lg shadow-lg bg-gray-50 mt-10 p-6">
         <div className="flex justify-end  text-center ">
           <button
             onClick={() => navigate(-1)}  // Use navigate(-1) to go back
             className="flex items-center text-green-600 hover:text-green-700 font-medium text-sm focus:outline-none"
           >
 
             <span>&lt; Back to Banner List</span>
           </button>
         </div>
     <h2 className="text-green-700 text-3xl font-bold text-center mb-6">
         Create Banner
       </h2>
       {/* Banner Image Section */}
       <div className="flex flex-col gap-6 mb-6 w-full sm:flex-row sm:gap-8 sm:mb-8">
         <div className="w-full sm:w-1/2">
           <label className="text-gray-700 font-medium mb-2 block">Banner Image</label>
           <div className="border rounded-md">
             {banner.banner_image ? (
               <div className="relative">
                 <img
                   src={URL.createObjectURL(banner.banner_image)}
                   alt="Banner Preview"
                   className="w-full h-44 object-cover rounded-md mb-4"
                 />
                 {/* <button
                   type="button"
                   className="absolute top-2 right-2 bg-red-500 text-white rounded-full px-2 py-1 text-xs"
                   onClick={() => setBanner({ ...banner, banner_image: null })}
                 >
                   Remove
                 </button> */}
               </div>
             ) : (
               <div className="w-full h-40 bg-gray-100 flex items-center justify-center rounded-md text-gray-500 mb-4">
                 No Image Selected
               </div>
             )}
             <input
               type="file"
               accept="image/*"
               onChange={(e) => {
                 const file = e.target.files[0];
                 
                 setBanner({ ...banner, banner_image: file });
               }}
               className="mb-3 ml-3 text-sm text-gray-600 file:mr-4 file:py-2 file:px-4
                      file:rounded-full file:border-0
                      file:text-sm file:font-semibold
                      file:bg-blue-50 file:text-blue-700
                      hover:file:bg-blue-100"
             />
           </div>
         </div>
 
         {/* Banner Details Section */}
         <div className="w-full sm:w-1/2">
           <div>
             <label className="text-gray-700 font-medium mb-2 block">Banner Name</label>
             <input
               type="text"
               name="title"
               value={banner.title}
               onChange={handleBannerChange}
               className={`w-full border p-2 rounded mb-3 ${!banner.title}`}
               placeholder="Enter banner name"
             />
           </div>
           <div>
             <label className="text-gray-700 font-medium mb-2 block">Start Date</label>
             <input
               type="date"
               name="start_date"
               value={banner.start_date}
               onChange={handleBannerChange}
               className="w-full border p-2 rounded mb-3"
             />
           </div>
           <div>
             <label className="text-gray-700 font-medium mb-2 block">End Date</label>
             <input
               type="date"
               name="end_date"
               value={banner.end_date}
               onChange={handleBannerChange}
               className="w-full border p-2 rounded"
             />
           </div>
            {/* Submit Button */}
     <div>
     <button
         onClick={handleSubmit}
         // disabled={
         //   isSubmitting || // Disable the button while submitting
         //   !banner.title ||
         //   !banner.banner_image ||
         //   !banner.start_date ||
         //   !banner.end_date ||
         //   selectedProducts.length === 0
         // }
         className={`w-full mt-6 px-6 py-3 rounded bg-green-600 hover:bg-green-700 text-white ${
           isSubmitting ||
           !banner.title ||
           !banner.banner_image ||
           !banner.start_date ||
           !banner.end_date ||
           selectedProducts.some((p) => !p.product_banner_image) ||
           selectedProducts.length === 0
            
           
         }`}
       >
         {isSubmitting ? "Submitting..." : "Submit Banner"}
       </button>
 
     </div>
         </div>
       </div>
     </div>
 
     {/* Products Table */}
     <div className="mt-6">
       <h2 className="text-xl font-bold mb-4">Products</h2>
       <div className="overflow-x-auto">
         <table className=" w-full text-left">
           <thead>
             <tr>
               <th className="py-2 px-2 text-green-500 text-sm font-bold ">Item No</th>
               <th className="py-2 px-2 text-green-500 text-sm font-bold ">Porduct Code</th>
               <th className="py-2 px-2 text-green-500 text-sm font-bold">Product Name</th>
               <th className="py-2 px-2 text-green-500 text-sm font-bold">Stock</th>
               <th className="py-2 px-2 text-green-500 text-sm font-bold">Price</th>
 
 
 
 
 
             </tr>
           </thead>
           <tbody>
             {products.map((product, index) => (
               <tr key={product.id} >
                 {/* Serial Number */}
                 <td className="py-2 px-2">
                   <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm flex items-center gap-2">
                     {index + 1}
                   </div>
                 </td>
 
                 <td className="py-2 px-2">
                   <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm flex items-center gap-2">
                     {product.product_code}
                   </div>
                 </td>
 
                 {/* Name */}
                 <td className="py-2 px-2">
                   <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm flex items-center gap-2">
                     {product.name}
                   </div>
                 </td>
                 {/* Stock */}
                 <td className="py-2 px-2">
                   <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm flex items-center gap-2">
                     {product.stock}
                   </div>
                 </td>
 
                 {/* Price */}
                 <td className="py-2 px-2">
                   <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm flex items-center gap-2">
                     {product.price}
                   </div>
                 </td>
 
                 {/* Upload Image Column */}
                 <td className="py-2 px-2">
                   <div className="flex-1 flex items-center ">
                     <input
                       type="file"
                       accept="image/*"
                       id={`upload-input-${product.id}`}
                       onChange={(e) => handleProductImageChange(e, product.id)}
                       className="hidden" // Hide the input
                     />
                     <label
                       htmlFor={`upload-input-${product.id}`} // Associate the label with the input
                       className="flex-1 flex items-center justify-center px-2 py-2 text-xs sm:text-sm font-medium text-blue-600 hover:text-white border border-blue-600 rounded-lg shadow-md hover:bg-blue-700 hover:border-blue-700 transition text-center"
                     >
                       Upload
                     </label>
                   </div>
                 </td>
 
                 {/* Image Column */}
                 <td className="py-2">
                   <div className="flex-1 flex items-center justify-center rounded-lg">
                     {selectedProducts.find((p) => p.product === product.id)?.product_banner_image || product.product_banner_image || product.image ? (
                       <img
                         src={
                           selectedProducts.find((p) => p.product === product.id)?.product_banner_image
                             ? URL.createObjectURL(
                               selectedProducts.find((p) => p.product === product.id).product_banner_image
                             )
                             : product.product_banner_image
                               ? URL.createObjectURL(product.product_banner_image)
                               : product.image
                         }
                         alt={product.name}
                         className="w-28 h-20 object-cover rounded shadow-md"
                       />
                     ) : (
                       <div className="w-28 h-20 flex items-center justify-center border border-gray-300 rounded bg-gray-100">
                         <span className="text-xs text-gray-500">No Image</span>
                       </div>
                     )}
                   </div>
                 </td>
 
                 {/* Action Buttons */}
                 <td className="py-2 px-2">
                   <div className="flex-1 flex items-center justify-center">
                     <button
                       onClick={() => handleProductSelect(product.id)}
                       className={`flex md:w-[130px] items-center justify-center py-2 text-xs sm:text-sm font-medium hover:text-white border rounded-lg shadow-md transition text-center ${selectedProducts.some((p) => p.product === product.id)
                           ? "text-red-600  border border-red-600 hover:bg-red-700 hover:border-red-700   "
                           : "text-green-600  border-green-600  hover:bg-green-700 hover:border-green-700  "
                         }`}
                     >
                       {selectedProducts.some((p) => p.product === product.id) ? "Remove" : "Add to Banner"}
                     </button>
                   </div>
                 </td>
               </tr>
             ))}
           </tbody>
 
         </table>
       </div>
     </div>
 
   </div>
   )
 }

export default AdminAddBanner